// utils/photoStep.js — paging through a pin's photos stops at the ends.
//
// 2026-09-15. Brett: "when im scrolling through photos on the card it just
// keeps scrolling through so i dont know when i have seen all the photos for
// that pin". Both viewers wrapped from the last photo back to the first, so
// there was no end to reach. Paging now stops at the first and the last
// photo, and the arrow at an end is not shown.

const whole = (v) => Math.floor(Number(v) || 0);

/** The index one step on (delta > 0) or back (delta < 0), held inside 0..count-1. */
export function stepPhoto(idx, delta, count) {
  const n = Math.max(0, whole(count));
  if (n === 0) return 0;
  const i = Math.min(Math.max(0, whole(idx)), n - 1);
  return Math.min(n - 1, Math.max(0, i + (Number(delta) < 0 ? -1 : 1)));
}

export const atFirstPhoto = (idx) => whole(idx) <= 0;
export const atLastPhoto = (idx, count) => whole(idx) >= Math.max(0, whole(count) - 1);
